/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicProgram,
    AcademicProgramFromJSON,
    AcademicProgramFromJSONTyped,
    AcademicProgramToJSON,
    CandidateOfferFiltersModalityList,
    CandidateOfferFiltersModalityListFromJSON,
    CandidateOfferFiltersModalityListFromJSONTyped,
    CandidateOfferFiltersModalityListToJSON,
    Presence,
    PresenceFromJSON,
    PresenceFromJSONTyped,
    PresenceToJSON,
    State,
    StateFromJSON,
    StateFromJSONTyped,
    StateToJSON,
} from './';

/**
 * Detalle filtros
 * @export
 * @interface CompanyOfferFilters
 */
export interface CompanyOfferFilters {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOfferFilters
     */
    showGeneral?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOfferFilters
     */
    showModalities?: boolean;
    /**
     * 
     * @type {Array<CandidateOfferFiltersModalityList>}
     * @memberof CompanyOfferFilters
     */
    modalityList?: Array<CandidateOfferFiltersModalityList>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOfferFilters
     */
    showStates?: boolean;
    /**
     * 
     * @type {Array<State>}
     * @memberof CompanyOfferFilters
     */
    stateList?: Array<State>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOfferFilters
     */
    showPresences?: boolean;
    /**
     * 
     * @type {Array<Presence>}
     * @memberof CompanyOfferFilters
     */
    presenceList?: Array<Presence>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyOfferFilters
     */
    showAcademicProgramScopes?: boolean;
    /**
     * 
     * @type {Array<AcademicProgram>}
     * @memberof CompanyOfferFilters
     */
    academicProgramScopeList?: Array<AcademicProgram>;
}

export function CompanyOfferFiltersFromJSON(json: any): CompanyOfferFilters {
    return CompanyOfferFiltersFromJSONTyped(json, false);
}

export function CompanyOfferFiltersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOfferFilters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showGeneral': !exists(json, 'show_general') ? undefined : json['show_general'],
        'showModalities': !exists(json, 'show_modalities') ? undefined : json['show_modalities'],
        'modalityList': !exists(json, 'modality_list') ? undefined : ((json['modality_list'] as Array<any>).map(CandidateOfferFiltersModalityListFromJSON)),
        'showStates': !exists(json, 'show_states') ? undefined : json['show_states'],
        'stateList': !exists(json, 'state_list') ? undefined : ((json['state_list'] as Array<any>).map(StateFromJSON)),
        'showPresences': !exists(json, 'show_presences') ? undefined : json['show_presences'],
        'presenceList': !exists(json, 'presence_list') ? undefined : ((json['presence_list'] as Array<any>).map(PresenceFromJSON)),
        'showAcademicProgramScopes': !exists(json, 'show_academic_program_scopes') ? undefined : json['show_academic_program_scopes'],
        'academicProgramScopeList': !exists(json, 'academic_program_scope_list') ? undefined : ((json['academic_program_scope_list'] as Array<any>).map(AcademicProgramFromJSON)),
    };
}

export function CompanyOfferFiltersToJSON(value?: CompanyOfferFilters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'show_general': value.showGeneral,
        'show_modalities': value.showModalities,
        'modality_list': value.modalityList === undefined ? undefined : ((value.modalityList as Array<any>).map(CandidateOfferFiltersModalityListToJSON)),
        'show_states': value.showStates,
        'state_list': value.stateList === undefined ? undefined : ((value.stateList as Array<any>).map(StateToJSON)),
        'show_presences': value.showPresences,
        'presence_list': value.presenceList === undefined ? undefined : ((value.presenceList as Array<any>).map(PresenceToJSON)),
        'show_academic_program_scopes': value.showAcademicProgramScopes,
        'academic_program_scope_list': value.academicProgramScopeList === undefined ? undefined : ((value.academicProgramScopeList as Array<any>).map(AcademicProgramToJSON)),
    };
}


